const isValidStripeImage = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:';
  } catch {
    return false;
  }
};

export const createCheckoutSession = async (cartItems, userEmail, shippingOption = null) => {
  const lineItems = cartItems
    .filter((item) => item.priceValue > 0)
    .map((item) => ({
      price_data: {
        currency: 'brl',
        product_data: {
          name: item.size ? `${item.name} - Tamanho ${item.size}` : item.name,
          ...(isValidStripeImage(item.thumbnail) ? { images: [item.thumbnail] } : {}),
        },
        unit_amount: Math.round(item.priceValue * 100),
      },
      quantity: item.quantity,
    }));

  if (lineItems.length === 0) {
    throw new Error('Carrinho vazio ou itens sem preço definido');
  }

  const base = process.env.REACT_APP_API_URL || '';
  const response = await fetch(`${base}/api/create-checkout-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      lineItems,
      customerEmail: userEmail,
      successUrl: `${window.location.origin}/success?session_id={CHECKOUT_SESSION_ID}`,
      cancelUrl: `${window.location.origin}/checkout`,
      shippingOption: shippingOption || null,
    }),
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Erro ao criar sessão de checkout');
  }

  const { sessionId, url } = await response.json();
  return { sessionId, url };
};

export const redirectToCheckout = async (cartItems, userEmail, shippingOption = null) => {
  // Salva carrinho e dados de frete no sessionStorage antes de sair da página
  sessionStorage.setItem('haka_pending_cart', JSON.stringify(cartItems));
  if (shippingOption) {
    sessionStorage.setItem('haka_pending_shipping', JSON.stringify(shippingOption));
  }

  try {
    const { url } = await createCheckoutSession(cartItems, userEmail, shippingOption);
    window.location.href = url;
  } catch (error) {
    sessionStorage.removeItem('haka_pending_cart');
    console.error('Erro ao redirecionar para checkout:', error);
    throw error;
  }
};
